import { useState } from "react";

export function Dropdown({ label, items, onItemClick, variant = "primary" }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="btn-group">
            <button
                type="button"
                className={`btn btn-${variant} dropdown-toggle btn-sm`}
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
                data-toggle="dropdown"
            >
                <span className="sr-only">{label}</span>
            </button>

            {/* Dropdown Menu */}
            <div className={`dropdown-menu ${isOpen ? "show" : ""}`}>
                {items.map((item, index) =>
                    item.divider ? (
                        <div key={index} className="dropdown-divider"></div>
                    ) : (
                        <button
                            key={index}
                            className="dropdown-item"
                            onClick={() => {
                                onItemClick(item.label);
                                setIsOpen(false);
                            }}
                        >
                            {item.label}
                        </button>
                    )
                )}
            </div>
        </div>
    );
}
